import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import products_fr from '../../data/products_fr';
import products_en from '../../data/products_en';
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

/* Nettoie le nom : "Coudounat (16°) - 70cl" -> "Coudounat"
   (on retire le degré entre parenthèses et le format après le tiret). */
const cleanName = (title = '') =>
  title.split(' (')[0].split(' - ')[0].trim();

const arrowStyle = (position) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: "40%",
  transform: "translateY(-50%)",
  backgroundColor: "rgba(255,255,255,0.9)",
  color: "#7c5b22",
  width: "44px",
  height: "44px",
  borderRadius: "50%",
  boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
  cursor: "pointer",
  zIndex: 10,
  transition: "all 0.3s ease-in-out",
  [position]: "10px",
});

function SampleNextArrow({ onClick }) {
  return (
    <div
      className="custom-arrow next-arrow"
      onClick={onClick}
      style={arrowStyle("right")}
      onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-50%) scale(1.1)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(-50%) scale(1)"; }}
    >
      <FaArrowRight />
    </div>
  );
}

function SamplePrevArrow({ onClick }) {
  return (
    <div
      className="custom-arrow prev-arrow"
      onClick={onClick}
      style={arrowStyle("left")}
      onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-50%) scale(1.1)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(-50%) scale(1)"; }}
    >
      <FaArrowLeft />
    </div>
  );
}

/* Carte produit épurée : image + nom uniquement. */
const MiniProductCard = ({ id, image, title }) => (
  <Link
    to={`/product/${id}`}
    className="group flex flex-col items-center px-4 py-6"
  >
    <div className="h-72 md:h-80 flex items-center justify-center">
      <img
        src={image}
        alt={title}
        loading="lazy"
        decoding="async"
        className="h-full w-auto object-contain transition-transform duration-500 group-hover:scale-105"
      />
    </div>
    <h3 className="font-sans mt-6 text-lg md:text-xl text-stone-800 text-center tracking-wide">
      {cleanName(title)}
    </h3>
    <span className="mt-2 h-px w-0 bg-amber-700/50 transition-all duration-500 group-hover:w-12" />
  </Link>
);

const Products = () => {
  const { i18n } = useTranslation();
  const products = i18n.language === 'fr' ? products_fr : products_en;

  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 900, settings: { slidesToShow: 2, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true } },
    ],
  };

  return (
    <div className="w-full max-w-6xl mx-auto">
      <Slider {...settings}>
        {products.map((product) => (
          <div key={product.id}>
            <MiniProductCard
              id={product.id}
              image={product.imageSm}
              title={product.title}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Products;